import validate from 'validate.js';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';
import React from 'react';

const validateGuestUpdateForm = (values) => {
  const {
    number_of_guests,
    addOns = [],
    alcohol_consumed,
    cardholders_name
  } = values;

  const validateAddOns = addOn => {
    const count = get(addOn, 'info.count', null);
    const maxCount = get(addOn, 'info.max_count') || 999;
    // don't want to validate against maxCount of 0
    const validateMaxCount = maxCount > 0 ? maxCount : null;

    return {
      info: {
        count: validate.single(
          count,
          {
            numericality: {
              lessThanOrEqualTo: validateMaxCount,
              notLessThanOrEqualTo: <FormattedMessage id='inbox.validate_guest_update_form.max_quantity' defaultMessage='The max quantity is {count}' values={{ count: maxCount }} />
            }
          }
        )
      }
    };
  };

  return {
    number_of_guests: validate.single(number_of_guests, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox.validate_guest_update_form.attendees' defaultMessage='Please enter the number of attendees.' />
      },
      numericality: {
        greaterThan: 0,
        lessThanOrEqualTo: 1000,
        message: <FormattedMessage id='inbox.validate_guest_update_form.attendees_less' defaultMessage='The number of attendees must be less than {num}.' values={{ num: 1000 }} />
      }
    }),
    addOns: addOns.map(validateAddOns),
    alcohol_consumed: validate.single(alcohol_consumed, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox.validate_guest_update_form.select_value' defaultMessage='Please select a value' />
      }
    }),
    cardholders_name: validate.single(cardholders_name, {
      presence: {
        allowEmpty: false,
        message: <FormattedMessage id='inbox.validate_guest_update_form.enter_name' defaultMessage="Enter cardholder's name and last name." />
      }
    })
  };
};

export default validateGuestUpdateForm;
